import React from 'react';

/**
 * Small alert-circle glyph (12x12 viewBox) used inside `SignalPill` and other
 * dense status indicators. Filled, currentColor.
 */
export function AlertIcon({
  className = 'h-3 w-3',
}: {
  className?: string;
}): React.ReactElement {
  return (
    <svg className={className} viewBox="0 0 12 12" fill="currentColor" aria-hidden="true">
      <path d="M6 0a6 6 0 100 12A6 6 0 006 0zm0 9a.75.75 0 110-1.5.75.75 0 010 1.5zm.75-3a.75.75 0 01-1.5 0V3.75a.75.75 0 011.5 0V6z" />
    </svg>
  );
}
